/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_Type_ActiveInputs */

const en_task_catalog_type_active = /** @type {(inputs: Task_Catalog_Type_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const pt_br2_task_catalog_type_active = /** @type {(inputs: Task_Catalog_Type_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativa`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Task_Catalog_Type_ActiveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_type_active = /** @type {((inputs?: Task_Catalog_Type_ActiveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Type_ActiveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_type_active(inputs)
	return pt_br2_task_catalog_type_active(inputs)
});